<template>
  <div id="tariff-calc-container">
    <div
      v-if="isInitializing"
      style="background-color: #fff; border: 1px solid #ddd; border-radius: 3px; padding: 1em; text-align: center; max-width: 500px;"
    >
      Initializing the Tariff Calculator
    </div>
    <entry-form
      v-if="!isInitializing && showEntryForm"
      :values="values"
      @submit="onSubmitClicked"
      @reset="onResetClicked"
    />
    <calculation-results
      v-if="!isInitializing && !showEntryForm"
      @reset="onAnotherCalculationClicked"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EntryForm from './components/EntryForm'
import CalculationResults from './components/CalculationResults'
import utils from './utils'

const initialValues = {
  areaId: 0,
  vesselLength: '',
  vesselBreadth: '',
  vesselDepth: '',
  vesselGrt: '',
  vesselUnits: 'M',
  assignmentTypeId: 31,
  expectedDuration: '',
  exectedDraft: '',
  draftUnits: 'M',
  needPilotBoat: 'Y',
}

export default {
  name: 'App',

  components: {
    EntryForm,
    CalculationResults,
  },

  data() {
    return {
      isInitializing: true,
      showEntryForm: true,

      values: utils.cloneObject(initialValues),
    }
  },

  methods: {
    onAnotherCalculationClicked() {
      this.showEntryForm = true
    },

    onSubmitClicked(values) {
      utils.log('calculate')
      this.calculate(values)
        .then(() => {
          utils.log('calculate complete')

          this.scrollToTop()

          this.showEntryForm = false
        })
        .catch(err => {
          utils.log('calculate failed', err)
        })
    },

    onResetClicked() {
      this.values = utils.cloneObject(initialValues)
    },

    scrollToTop() {
      this.$scrollTo('#tariff-calc-container')
    },

    ...mapActions(['initialize', 'calculate']),
  },

  created() {
    utils.log('initialize')
    this.initialize()
      .then(() => {
        utils.log('initialize complete')
        this.isInitializing = false
      })
      .catch(err => {
        utils.log('initialize failts', err)
      })
  },
}
</script>

<style>
table#TariffCalculator {
  width: 100%;
}

table#TariffCalculator tbody th,
table#TariffCalculator tbody td {
  background: white !important;
}

table#TariffCalculator tbody label {
  color: #000 !important;
  font-size: 13px;
  font-weight: normal;
}

table#TariffCalculator select,
table#TariffCalculator input {
  margin: 0 !important;
}

#TariffCalculator label {
  display: inline;
}

#TariffCalculator input,
#TariffCalculator select {
  width: 100%;
}

#TariffCalculator span.error {
  display: inline-block;
  margin-top: 3px;
  padding: 2px 5px;
  color: white;
  background-color: red;
  border-radius: 3px;
  font-size: 9pt;
}
</style>
